/* import __COLOCATED_TEMPLATE__ from './cvda-text-filter.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'embercom/services/intl';
import { tracked } from '@glimmer/tracking';

interface Signature {
  Element: HTMLElement;
  Args: {
    selected?: string;
    onSelect: (value: string) => void;
  };
}

export default class CvdaTextFilter extends Component<Signature> {
  @service declare intl: IntlService;
  @tracked selectedRadioButtonValue = 'eq';

  get radioButtons() {
    return [
      {
        value: 'eq',
        label: this.intl.t('inbox.search.filters.more-filters.is'),
      },
    ];
  }

  @action onSelect(value: string) {
    this.args.onSelect(value);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Search::CvdaTextFilter': typeof CvdaTextFilter;
  }
}
